// third-party
import { FormattedMessage } from "react-intl";

// assets
import { UserAdd } from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  user: UserAdd,
};

// ==============================|| MENU ITEMS - WIDGETS ||============================== //

const user: NavItemType = {
  id: "group-users",
  title: <FormattedMessage id="page.menu_items_user_label" />,
  icon: icons.user,
  type: "group",
  children: [
    {
      id: "user",
      title: <FormattedMessage id="page.menu_items_user_label" />,
      type: "item",
      url: "/user/list",
      icon: icons.user,
    },
  ],
};

export default user;
